import React from "react";
import { ICartAdProps } from "./CartAdProps";
import { Container } from "./CartAdHelpers";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { useSelector } from "react-redux";

const CartAd: React.FC<ICartAdProps> = (props) => {
  const checkoutObj = useSelector((state: any) => state.checkout);
  const AdData = props.node ? props.node : null;
  const hotelExclusionList = AdData
    ? AdData.relationships.field_hotel_exclusion_list
    : [];
  const image = AdData?.relationships.field_media
    ? getImage(
        AdData.relationships.field_media.relationships.field_media_image
          .gatsbyImage as any
      )
    : null;

  const handleClick = (url: string) => {
    if (url) {
      window.open(url, "_blank");
    }
  };

  if (
    AdData &&
    !hotelExclusionList.some(
      (hotel) => hotel.crs_code === checkoutObj.HotelCode
    )
  ) {
    return (
      <Container>
        <Row>
          <div className="adTitle">{AdData.field_title}</div>
        </Row>
        <Row className="body-row">
          <Col lg={4}>
            <div className="adImage">
              {image ? (
                <GatsbyImage
                  image={image}
                  alt={AdData.relationships.field_media.field_media_image.alt}
                />
              ) : null}
            </div>
          </Col>
          <Col lg={image ? 8 : 12}>
            <div
              className="adBody"
              dangerouslySetInnerHTML={{
                __html: AdData.field_description_formatted.value,
              }}
            />
          </Col>
        </Row>
        {AdData.field_link && (
          <Row>
            <div className="adLink">
              <Button
                className="text-uppercase"
                onClick={() => handleClick(AdData.field_link.url)}
              >
                {AdData.field_link.title}
              </Button>
            </div>
          </Row>
        )}
      </Container>
    );
  } else {
    return null;
  }
};

export default CartAd;
